export default __webpack_public_path__ + "static/media/motorcycle-plat.b9f440a4.svg";